export enum PickUpDates {
  ASAP = 'As soon as possible',
  ThisWeek = 'This week',
  ThisMonth = 'This month',
}
